module.exports = __webpack_public_path__ + "img/seller_pays_commissitions.d05ed0f0.svg";